// Segment 2 — Trail Markers
// Almost-empty full-viewport card by design.
const Segment2 = () => (
  <div
    className="flex items-center justify-center"
    style={{ minHeight: 'calc(100vh - 18rem)' }}
    data-testid="trail-markers-card"
  >
    <div className="bg-white rounded-3xl px-12 py-16 text-center max-w-2xl w-full shadow-sm">
      <p className="text-4xl md:text-5xl lg:text-6xl font-bold text-ink mb-10 leading-tight">
        Look up — we're at<br />the boards 📌
      </p>

      <div className="space-y-4 text-left inline-block">
        <p className="text-lg md:text-xl text-ink-secondary flex items-center gap-3">
          <span className="w-4 h-4 rounded-full bg-brand-orange shrink-0" />
          <span>Nonprofits &nbsp;·&nbsp; orange notes → <strong className="text-ink">The Need Board</strong></span>
        </p>
        <p className="text-lg md:text-xl text-ink-secondary flex items-center gap-3">
          <span className="w-4 h-4 rounded-full bg-yellow-400 shrink-0" />
          <span>Mentors &nbsp;·&nbsp; yellow notes → <strong className="text-ink">The Fuel Board</strong></span>
        </p>
      </div>
    </div>
  </div>
);

export default Segment2;
